export default __webpack_public_path__ + "static/media/7.226ec14d.svg";